import { compact, isEmpty } from 'lodash';
import { makeStyles } from 'tss-react/mui';

import { breadcrumbsClasses, buttonClasses } from '@mui/material';

import { MayBeNil } from 'app/@types/utils/may-be-nil';
import { MOBILE_BREAK_POINT } from 'app/constants';
import { isLightMode } from 'pages/Landings/utils';

export default makeStyles<{ buttons: boolean; illustration: boolean; smaller: boolean }>({ name: 'TitleSection' })(
    (theme, { buttons, illustration, smaller }) => {
        const templates = {
            desktop: formatGridTemplateAreas([
                ['breadcrumbs', illustration ? 'illustration' : null],
                ['text', illustration ? 'illustration' : null],
                buttons ? ['buttons', illustration ? 'illustration' : null] : []
            ]),
            mobile: formatGridTemplateAreas([
                ['breadcrumbs'],
                illustration ? ['illustration'] : [],
                ['text'],
                buttons ? ['buttons'] : []
            ])
        };
        return {
            root: {
                width: '100%',
                display: 'grid',
                gridTemplateColumns: '640px 1fr',
                gridTemplateAreas: templates.desktop,
                gap: '56px 0',
                [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
                    gridTemplateColumns: '1fr',
                    gridTemplateAreas: templates.mobile,
                    gap: '40px 0'
                }
            },
            breadcrumbs: {
                gridArea: 'breadcrumbs',
                [`.${breadcrumbsClasses.ol}`]: {
                    color: isLightMode(theme) ? '#232323' : '#fff',
                    fontSize: 24,
                    fontWeight: 500,
                    lineHeight: '150%',
                    letterSpacing: '-0.72px',
                    [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
                        fontSize: 18,
                        lineHeight: '27px',
                        letterSpacing: '-0.54px',
                        justifyContent: 'center'
                    }
                },
                [`.${breadcrumbsClasses.separator}`]: {
                    color: '#F5726A'
                }
            },
            breadcrumb: {
                color: '#F5726A',
                textDecoration: 'none',
                transition: 'all 0.2s',
                '&:hover': {
                    opacity: 0.8
                },
                '&:active': {
                    opacity: 1
                }
            },
            text: {
                gridArea: 'text',
                display: 'flex',
                flexDirection: 'column',
                gap: 24
            },
            description: {
                margin: 0,
                color: isLightMode(theme) ? '#232323' : '#fff',
                fontSize: smaller ? 20 : 24,
                fontWeight: 500,
                lineHeight: smaller ? '30px' : '36px',
                letterSpacing: smaller ? '-0.6px' : '-0.72px',
                wordBreak: 'break-word',
                [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
                    textAlign: 'center',
                    fontSize: 18,
                    lineHeight: '27px',
                    letterSpacing: '-0.54px'
                }
            },
            buttons: {
                gridArea: 'buttons',
                display: 'flex',
                alignItems: 'flex-start',
                gap: 12,
                [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
                    flexDirection: 'column',
                    [`& .${buttonClasses.root}`]: {
                        width: '100%'
                    }
                }
            },
            illustration: {
                gridArea: 'illustration',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                ['svg']: {
                    width: 320,
                    height: 320
                },
                [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
                    justifyContent: 'center',
                    ['svg']: {
                        width: 160,
                        height: 160
                    }
                }
            }
        };
    }
);

function formatGridTemplateAreas(templates: MayBeNil<string>[][]) {
    return templates
        .map((line) => compact(line))
        .filter((line) => !isEmpty(line))
        .map((line) => `"${line.join(' ')}"`)
        .join('\n');
}
